/* ET home — shared script for the homepage mosaic (sections/et-home-mosaic.liquid) and the
 * category shelves (sections/et-home-shelves.liquid). Vanilla JS, no libraries.
 *
 * What it does
 *  1. Runs the hero carousel (same behaviour as the old et-hero: interval, pause on hover / keyboard
 *     focus / hidden tab, swipe, inert on hidden slides, theme-editor block select).
 *  2. Fetches GET /apps/toolbox/api/home ONCE (anonymous allowed) and hands the JSON to apply().
 *  3. apply(json) is also public: window.etHome.apply(sample) renders any state by hand.
 *
 * The server-rendered Liquid is always a complete page on its own. If the feed 404s or fails we log
 * one warning and leave it alone. Every localStorage / sessionStorage access is wrapped in try/catch.
 */
(function () {
  'use strict';
  if (window.etHome) return;
  var doc = document, win = window;
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var reduce = !!(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var VIS_KEY = 'et_home_visits', SES_KEY = 'et_home_session', VIEW_KEY = 'et_recent_v1';
  var ARROW = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8h9.5M8.5 4l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var last = null;

  /* ---------- storage (always guarded) ---------- */
  function lsGet(k) { try { return win.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { win.localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  function ssGet(k) { try { return win.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { win.sessionStorage.setItem(k, v); } catch (e) { /* private mode */ } }

  // Visit index: 0 on a browser's first session, +1 per later session. Bumped once per session.
  var V = (function () {
    var n = parseInt(lsGet(VIS_KEY), 10) || 0;
    if (!ssGet(SES_KEY)) { n += 1; lsSet(VIS_KEY, String(n)); ssSet(SES_KEY, '1'); }
    return Math.max(0, n - 1);
  })();

  function readViewed() {
    var out = [];
    try {
      var a = JSON.parse(lsGet(VIEW_KEY) || '[]');
      if (Array.isArray(a)) a.forEach(function (x) { if (x && typeof x.h === 'string' && out.length < 12) out.push({ h: x.h, t: +x.t || 0 }); });
    } catch (e) { /* ignore */ }
    return out;
  }

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function arr(x) { return Array.isArray(x) ? x : []; }
  var moneyFmt = '${{amount}}';
  function money(n) {
    if (n == null || isNaN(n)) return '';
    var amt = (Math.round(+n * 100) / 100).toFixed(2);
    return moneyFmt.replace(/\{\{\s*amount[^}]*\}\}/, amt.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function img(url, w) {
    if (!url) return '';
    if (/^https?:\/\/cdn\.shopify\.com\//.test(url) || /^\/\/cdn\.shopify\.com\//.test(url)) return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    return url;
  }
  function md(s) { // 'YYYY-MM-DD' -> 'Oct 8'
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s || '');
    return m ? MON[parseInt(m[2], 10) - 1] + ' ' + parseInt(m[3], 10) : '';
  }
  function num(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
  function rot(list, k) {
    if (!list.length) return [];
    k = k % list.length;
    return list.slice(k).concat(list.slice(0, k));
  }
  function viewedTag(ts) {
    if (!ts) return 'Viewed recently';
    var now = new Date(), then = new Date(ts);
    var d0 = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    var d1 = new Date(then.getFullYear(), then.getMonth(), then.getDate()).getTime();
    var days = Math.round((d0 - d1) / 864e5);
    if (days <= 0) return 'Viewed today';
    if (days < 7) return 'Viewed ' + DAY[then.getDay()];
    return 'Viewed recently';
  }
  function todayISO() {
    var n = new Date(), m = n.getMonth() + 1, d = n.getDate();
    return n.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d;
  }
  // next_due can be in the past (overdue): say "Due now", never print a past date.
  function dueTag(nd) {
    if (!/^\d{4}-\d{2}-\d{2}/.test(nd || '')) return 'Due soon';
    return nd.slice(0, 10) <= todayISO() ? 'Due now' : 'Due around ' + md(nd);
  }
  function prodOk(p) { return p && p.handle && p.available !== false; }

  /* ---------- section discovery ---------- */
  function readJSON(root) {
    var s = root.querySelector('script[data-et-json]');
    if (!s) return {};
    try { return JSON.parse(s.textContent) || {}; } catch (e) { return {}; }
  }

  /* =====================================================================
   * MOSAIC
   * ===================================================================== */
  function initCarousel(root) {
    var car = root.querySelector('[data-ehm-carousel]');
    if (!car || car.dataset.ready) return;
    car.dataset.ready = '1';
    var slides = car.querySelectorAll('[data-slide]');
    var segs = car.querySelectorAll('[data-go]');
    var chip = car.querySelector('[data-chip]');
    var pauseBtn = car.querySelector('[data-pause]');
    var n = slides.length;
    if (n < 2) return;
    var ms = Math.max(4, parseInt(car.dataset.interval, 10) || 7) * 1000;
    var i = 0, timer = null, userPaused = reduce, hover = false, focus = false;
    function show(k) {
      i = (k + n) % n;
      slides.forEach(function (s, j) {
        var on = j === i;
        s.classList.toggle('is-active', on);
        if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
        else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
      });
      segs.forEach(function (d, j) { if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      if (chip) chip.textContent = 'Featured · ' + (i + 1) + ' of ' + n;
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() { stop(); if (!userPaused && !hover && !focus && !doc.hidden) timer = setInterval(function () { show(i + 1); }, ms); }
    function syncPause() {
      car.classList.toggle('is-paused', userPaused);
      if (pauseBtn) pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
    }
    segs.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.dataset.go, 10)); start(); }); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { userPaused = !userPaused; syncPause(); start(); });
    car.addEventListener('mouseenter', function () { hover = true; stop(); });
    car.addEventListener('mouseleave', function () { hover = false; start(); });
    car.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches(':focus-visible')) { focus = true; stop(); } });
    car.addEventListener('focusout', function (e) { if (!car.contains(e.relatedTarget)) { focus = false; start(); } });
    doc.addEventListener('visibilitychange', start);
    var x0 = null, y0 = null;
    car.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    car.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { show(i + (dx < 0 ? 1 : -1)); start(); }
    }, { passive: true });
    if (win.Shopify && win.Shopify.designMode) {
      doc.addEventListener('shopify:block:select', function (e) {
        var k = Array.prototype.indexOf.call(slides, e.target);
        if (k > -1 && car.contains(e.target)) { userPaused = true; syncPause(); show(k); stop(); }
      });
    }
    syncPause();
    start();
  }

  // Card row arrows
  function initCards(m) {
    var wrap = m.cards;
    if (!wrap || wrap.dataset.ready) return;
    wrap.dataset.ready = '1';
    var track = wrap.querySelector('[data-track]');
    var prev = wrap.querySelector('[data-prev]');
    var next = wrap.querySelector('[data-next]');
    if (!track || !next || !prev) return;
    var raf = 0;
    function sync() {
      raf = 0;
      var max = track.scrollWidth - track.clientWidth;
      var over = max > 4;
      next.hidden = !over || track.scrollLeft >= max - 4;
      prev.hidden = !over || track.scrollLeft <= 4;
    }
    function queue() { if (!raf) raf = win.setTimeout(sync, 40); }
    function page(dir) {
      var c = track.querySelector('.ehm__card');
      var pitch = c ? c.getBoundingClientRect().width + 16 : track.clientWidth;
      var per = Math.max(1, Math.floor((track.clientWidth + 16) / pitch));
      track.scrollBy({ left: dir * per * pitch, behavior: reduce ? 'auto' : 'smooth' });
    }
    next.addEventListener('click', function () { page(1); });
    prev.addEventListener('click', function () { page(-1); });
    track.addEventListener('scroll', queue, { passive: true });
    win.addEventListener('resize', queue);
    m.syncArrows = queue;
    queue();
  }

  function cardHTML(s) {
    var p = s.p;
    return '<a class="ehm__card" href="/products/' + esc(p.handle) + '" data-handle="' + esc(p.handle) + '" data-line="' + esc(p.line || '') + '">' +
      '<span class="ehm__card-label"><b>' + esc(s.label) + '</b>' + ARROW + '</span>' +
      '<span class="ehm__card-img">' + (p.image ? '<img src="' + esc(img(p.image, 260)) + '" alt="" width="112" height="112" loading="lazy">' : '') + '</span>' +
      '<span class="ehm__card-title">' + esc(p.title) + '</span>' +
      '<span class="ehm__card-foot"><b>' + esc(money(p.price)) + '</b>' + (s.tag ? '<i class="ehm__tag' + (s.kind ? ' ehm__tag--' + s.kind : '') + '">' + esc(s.tag) + '</i>' : '') + '</span></a>';
  }

  // Pick the cards. Returns { slots: [5], extra: [..] } of { label, p, tag, kind }.
  function chooseCards(d, m, ctx) {
    var L = d.lists || {};
    var usedH = {}, usedL = {}, usedLabel = {};
    m.pinned.forEach(function (h) { usedH[h] = 1; });
    function ok(p) { return prodOk(p) && !usedH[p.handle] && !(p.line && usedL[p.line]); }
    function mark(p) { usedH[p.handle] = 1; if (p.line) usedL[p.line] = 1; }
    var usedV = {};
    function take(list, distinct) {
      var i;
      if (distinct) {
        for (i = 0; i < list.length; i++) if (ok(list[i]) && !usedV[list[i].vendor || '']) { mark(list[i]); usedV[list[i].vendor || ''] = 1; return list[i]; }
      }
      for (i = 0; i < list.length; i++) if (ok(list[i])) { mark(list[i]); usedV[list[i].vendor || ''] = 1; return list[i]; }
      return null;
    }
    function uniq(label) {
      var alt = { 'Best Seller': 'Popular Right Now', 'Popular Right Now': 'Also Popular' };
      while (usedLabel[label] && alt[label]) label = alt[label];
      usedLabel[label] = 1;
      return label;
    }
    var viewedMap = {};
    readViewed().forEach(function (v) { viewedMap[v.h] = v.t; });
    function tradeList(h) {
      var out = [];
      arr(d.trades).forEach(function (t) { if (t && t.handle === h) out = arr(t.products); });
      return rot(out, V);
    }
    var tA = ctx.tradeA, tB = ctx.tradeB;
    var best = rot(arr(L.best), V), fresh = rot(arr(L.new), V), viewed = arr(L.viewed);
    function src(label, list, tagFn, distinct) { return { label: label, list: list, tag: tagFn, distinct: distinct }; }
    var bestSrc = src('Best Seller', best, function (p) { return { t: p.vendor || '' }; });
    var newSrc = src('New This Month', fresh, function () { return { t: 'NEW', k: 'new' }; }, true);
    var viewedSrc = src('Keep Shopping For', viewed, function (p) { return { t: viewedTag(viewedMap[p.handle]) }; });
    function tradeSrc(t) { return t ? src('Top in ' + t.short, tradeList(t.handle), function () { return { t: t.short }; }) : null; }
    var chains;
    if (ctx.linked) {
      var rec = src('Recommended for You', rot(arr(L.recommended), V), function (p) { return { t: p.reason_kind === 'copurchase' ? 'Pairs well' : 'For your trade' }; });
      chains = [
        [src('Buy It Again', rot(arr(L.buy_again), V), function (p) { return { t: 'Bought ' + (p.times || 1) + '×' }; }), bestSrc],
        [src('Due for Restock', rot(arr(L.due), V), function (p) { return { t: dueTag(p.next_due), k: 'due' }; }), rec, bestSrc],
        [rec, tradeSrc(tA), bestSrc],
        [newSrc, bestSrc],
        [viewedSrc, tradeSrc(tB), tradeSrc(tA), bestSrc]
      ];
    } else {
      chains = [
        [bestSrc, newSrc],
        [tradeSrc(tA), bestSrc],
        [newSrc, bestSrc],
        [tradeSrc(tB), bestSrc],
        [viewed.length ? viewedSrc : null, bestSrc]
      ];
    }
    var slots = [], page2 = [];
    chains.forEach(function (chain, idx) {
      var pinned = m.pinnedSlots[idx];
      if (pinned) { slots.push(null); return; }
      var got = null;
      for (var k = 0; k < chain.length && !got; k++) {
        var c = chain[k];
        if (!c) continue;
        var p = take(c.list, c.distinct);
        if (p) { var t = c.tag(p); got = { label: uniq(c.label), p: p, tag: t.t, kind: t.k }; }
      }
      slots.push(got);
    });
    // second page: the next unused item from each slot's own list
    chains.forEach(function (chain, idx) {
      var c = chain[0] || chain[1];
      if (!c) return;
      var p = take(c.list, c.distinct);
      if (p) { var t = c.tag(p); page2.push({ label: c.label, p: p, tag: t.t, kind: t.k }); }
    });
    return { slots: slots, extra: page2.length >= 3 ? page2 : [] };
  }

  function renderCards(m, d, ctx) {
    var track = m.track;
    if (!track || !d.lists) return;
    var res = chooseCards(d, m, ctx);
    var nodes = Array.prototype.slice.call(track.children);
    var html = [];
    for (var i = 0; i < 5; i++) {
      var s = res.slots[i];
      if (m.pinnedSlots[i]) { html.push(nodes[i] ? nodes[i].outerHTML : ''); continue; }
      html.push(s ? cardHTML(s) : (nodes[i] ? nodes[i].outerHTML : ''));
    }
    res.extra.forEach(function (s) { html.push(cardHTML(s)); });
    track.innerHTML = html.join('');
    track.scrollLeft = 0;
    if (m.syncArrows) m.syncArrows();
  }

  function tradeBlocks(m) { return arr(m.data.trades); }
  function findTrade(m, h) { var r = null; tradeBlocks(m).forEach(function (t) { if (t.handle === h) r = t; }); return r; }

  function renderGuide(m, d, ctx) {
    var tile = m.tiles.guide;
    var list = arr(m.data.articles);
    if (!tile || !list.length) return;
    var tradeBlock = ctx.tradeKnown ? ctx.tradeA : null;
    var pool = list, matched = false;
    if (tradeBlock && tradeBlock.tag) {
      var tg = tradeBlock.tag.toLowerCase();
      var hit = list.filter(function (a) { return arr(a.tags).some(function (t) { return String(t).toLowerCase() === tg; }); });
      if (hit.length) { pool = hit.slice(0, 5); matched = true; }
    }
    if (!matched) pool = list.slice(0, 6);
    var a = pool[V % pool.length];
    var isNewest = !matched && a === list[0];
    var eyebrow = matched ? 'Picked for Your Trade' : (isNewest ? 'New in the Guides' : 'From the Guides') + (a.date ? ' · ' + md(a.date) : '');
    tile.setAttribute('href', a.url);
    tile.innerHTML =
      '<span class="ehm__g-img">' + (a.image ? '<img src="' + esc(img(a.image, 600)) + '" alt="" width="300" height="148" loading="eager">' : '') + '</span>' +
      '<span class="ehm__g-body"><span class="ehm__eyebrow ehm__eyebrow--rust">' + esc(eyebrow) + '</span>' +
      '<span class="ehm__g-title">' + esc(a.title) + '</span>' +
      '<span class="ehm__g-foot"><span class="ehm__g-read">Read the Guide ' + ARROW + '</span>' +
      (a.audio ? '<span class="ehm__listen"><svg viewBox="0 0 10 10" aria-hidden="true" focusable="false"><path d="M2 1l7 4-7 4z" fill="currentColor"/></svg>Listen</span>' : '') +
      '</span></span>';
  }

  function renderLanded(m, d) {
    var tile = m.tiles.landed;
    if (!tile || tile.hasAttribute('data-pinned')) return;
    var jl = arr(d.just_landed);
    if (!jl.length) return;
    var g = jl[V % jl.length];
    if (!g || !g.type) return;
    var vendors = arr(g.vendors).filter(Boolean);
    var from = vendors.length === 1 ? 'From ' + vendors[0] : vendors.length === 2 ? 'From ' + vendors[0] + ' and ' + vendors[1] : vendors.length > 2 ? 'From ' + vendors[0] + ', ' + vendors[1] + ' and others' : '';
    var count = +g.count || 0;
    var key = g.type + '|' + count;
    if (tile.getAttribute('data-key') === key) return;
    tile.setAttribute('data-key', key);
    var title = count > 1 ? num(count) + ' new ' + g.type : 'New in ' + g.type;
    var href = g.collection ? '/collections/' + encodeURIComponent(g.collection) : '/collections/all?sort_by=created-descending';
    tile.setAttribute('href', href);
    tile.innerHTML =
      '<span class="ehm__eyebrow ehm__eyebrow--light">Just Landed' + (g.newest ? ' · ' + esc(md(g.newest)) : '') + '</span>' +
      '<span class="ehm__l-title">' + esc(title) + '</span>' +
      (from ? '<span class="ehm__l-sub">' + esc(from) + '</span>' : '') +
      '<span class="ehm__l-thumbs">' + arr(g.images).slice(0, 3).map(function (u) { return '<span><img src="' + esc(img(u, 160)) + '" alt="" width="80" height="80" loading="lazy"></span>'; }).join('') + '</span>' +
      '<span class="ehm__l-btn">Shop ' + esc(g.type) + ' ' + ARROW + '</span>';
  }

  function renderTrade(m, ctx) {
    var tile = m.tiles.trade;
    var t = ctx.tradeA;
    if (!tile || !t) return;
    var key = t.handle + '|' + (ctx.tradeKnown ? '1' : '0');
    if (tile.getAttribute('data-key') === key) return;
    tile.setAttribute('data-key', key);
    var text = String(t.text || '').replace(/[.\s]+$/, '');
    var sub = (text ? text + '. ' : '') + (t.count ? num(t.count) + ' products.' : '');
    tile.setAttribute('href', t.url);
    tile.innerHTML =
      (t.image ? '<img class="ehm__t-bg" src="' + esc(t.image) + '" alt="" loading="eager" width="400" height="336">' : '') +
      '<span class="ehm__t-flag">' + (ctx.tradeKnown ? 'Picked for Your Trade' : 'Shop by Trade') + '</span>' +
      '<span class="ehm__t-copy"><span class="ehm__t-title">' + esc(t.heading) + '</span>' +
      (sub ? '<span class="ehm__t-sub">' + esc(sub) + '</span>' : '') +
      '<span class="ehm__t-link">Shop ' + esc(t.short) + ' ' + ARROW + '</span></span>';
  }

  function toolboxIn(d) {
    var tb = d.toolbox || {};
    var name = typeof d.first_name === 'string' ? d.first_name.trim() : '';
    function row(href, n, one, many, plain) {
      var inner = n > 0 ? '<b>' + n + '</b><span>' + esc(n === 1 ? one : many) + '</span>' : '<span class="ehm__plain">' + esc(plain) + '</span>';
      return '<li><a class="ehm__tb-row" href="' + href + '">' + inner + ARROW + '</a></li>';
    }
    return '<span class="ehm__eyebrow ehm__eyebrow--light">My Toolbox</span>' +
      '<span class="ehm__tb-title" role="heading" aria-level="2">' + (name ? 'Welcome back, ' + esc(name) + '.' : 'Welcome back.') + '</span>' +
      '<ul class="ehm__tb-rows">' +
      row('/apps/toolbox/restocking', +tb.due || 0, 'item due for restock', 'items due for restock', 'Restocking suggestions') +
      row('/apps/toolbox/orders', +tb.on_the_way || 0, 'order on the way', 'orders on the way', 'Orders & tracking') +
      row('/apps/toolbox/invoices', +tb.recent_invoices || 0, 'invoice this month', 'invoices this month', 'Invoices & statements') +
      '</ul><a class="ehm__tb-btn" href="/apps/toolbox">Open My Toolbox</a>';
  }

  function renderToolbox(m, d) {
    var tile = m.tiles.toolbox;
    if (!tile) return;
    if (d.signed_in) {
      tile.setAttribute('data-state', 'in');
      tile.innerHTML = toolboxIn(d);
    } else if (m.tbOrig && tile.getAttribute('data-state') === 'in' && !m.forced) {
      tile.setAttribute('data-state', 'out');
      tile.innerHTML = m.tbOrig;
    }
  }

  function computeCtx(m, d) {
    var blocks = tradeBlocks(m);
    var tradeKnown = false, A = null;
    if (d.trade && d.trade.handle) { A = findTrade(m, d.trade.handle); tradeKnown = !!A; }
    var idxA = 0;
    if (!A && blocks.length) { idxA = V % blocks.length; A = blocks[idxA]; }
    else if (A) idxA = blocks.indexOf(A);
    var B = blocks.length > 1 ? blocks[(idxA + 1) % blocks.length] : null;
    return { linked: !!(d.signed_in && d.linked), tradeKnown: tradeKnown, tradeA: A, tradeB: B };
  }

  function renderMosaic(m, d) {
    var ctx = computeCtx(m, d);
    renderGuide(m, d, ctx);
    renderLanded(m, d);
    renderTrade(m, ctx);
    renderToolbox(m, d);
    renderCards(m, d, ctx);
  }

  /* =====================================================================
   * SHELVES
   * ===================================================================== */
  function pill(text, kind) { return '<span class="ehs__pill ehs__pill--' + kind + '">' + esc(text) + '</span>'; }
  function cellHTML(it) {
    var p = it.p;
    return '<a class="ehs__cell" href="/products/' + esc(p.handle) + '" data-handle="' + esc(p.handle) + '">' +
      '<span class="ehs__cell-img">' + (p.image ? '<img src="' + esc(img(p.image, 320)) + '" alt="" width="160" height="120" loading="lazy">' : '') + '</span>' +
      '<span class="ehs__cell-title">' + esc(p.title) + '</span>' +
      '<span class="ehs__cell-price"><b>' + esc(money(p.price)) + '</b>' + (it.note ? '<i>' + esc(it.note) + '</i>' : '') + '</span></a>';
  }
  function colHTML(c) {
    return '<article class="ehs__card ehs__card--blue" data-col>' +
      '<div class="ehs__card-head"><h4>' + esc(c.title) + '</h4>' + (c.tag ? pill(c.tag, c.kind || 'dark') : '') + '</div>' +
      '<div class="ehs__cells">' + c.items.map(cellHTML).join('') + '</div>' +
      '<div class="ehs__card-foot">' + (c.href ? '<a href="' + esc(c.href) + '">' + esc(c.footer) + ' ' + ARROW + '</a>' : '<span>' + esc(c.footer) + '</span>') + '</div></article>';
  }

  function guideRow(a) {
    return '<a class="ehs__g" href="' + esc(a.url) + '"><span class="ehs__g-img">' + (a.image ? '<img src="' + esc(img(a.image, 220)) + '" alt="" width="96" height="62" loading="lazy">' : '') + '</span>' +
      '<span class="ehs__g-text">' + (a.kicker ? '<span class="ehs__g-kicker">' + esc(a.kicker) + '</span>' : '') + '<span class="ehs__g-title">' + esc(a.title) + '</span></span></a>';
  }

  function renderShelves(s, d) {
    var L = d.lists || {};
    var linked = !!(d.signed_in && d.linked);
    var blocks = arr(s.data.trades);
    // sub-header + count line
    var h = s.head, sub = s.sub;
    if (h && d.lists) {
      h.textContent = linked ? 'Picked for Your Shop' : 'Popular Right Now';
      if (sub) sub.textContent = linked ? 'Changes every visit, based on what you order and look at' : 'Changes every visit: best sellers, new arrivals and what each trade is buying';
    }
    if (s.count && d.catalog && +d.catalog.products > 0) {
      s.count.textContent = num(+d.catalog.products) + ' products' + (+d.catalog.new_30d > 0 ? ' · ' + num(+d.catalog.new_30d) + ' added in the last 30 days' : '');
      s.count.hidden = false;
    }
    // guides column: trade-matched first when the trade is known
    var guides = arr(s.data.articles);
    var tradeBlock = null;
    if (d.trade && d.trade.handle) blocks.forEach(function (b) { if (b.handle === d.trade.handle) tradeBlock = b; });
    if (s.guides && guides.length) {
      var rows = guides.slice();
      if (tradeBlock && tradeBlock.tag) {
        var tg = tradeBlock.tag.toLowerCase();
        var hit = rows.filter(function (a) { return arr(a.tags).some(function (t) { return String(t).toLowerCase() === tg; }); });
        rows = hit.concat(rows.filter(function (a) { return hit.indexOf(a) < 0; }));
      }
      s.guides.innerHTML = rows.slice(0, 4).map(guideRow).join('');
    }
    if (!d.lists) return;

    var used = {};
    function ok(p) { return prodOk(p) && !used[p.handle]; }
    function takeN(list, n, distinct) {
      var out = [], seen = {}, i;
      if (distinct) {
        for (i = 0; i < list.length && out.length < n; i++) if (ok(list[i]) && !seen[list[i].vendor || '']) { seen[list[i].vendor || ''] = 1; used[list[i].handle] = 1; out.push(list[i]); }
      }
      for (i = 0; i < list.length && out.length < n; i++) if (ok(list[i])) { used[list[i].handle] = 1; out.push(list[i]); }
      return out;
    }
    function items(list, noteFn, distinct) { return takeN(list, 4, distinct).map(function (p) { return { p: p, note: noteFn ? noteFn(p) : '' }; }); }
    function tradeProducts(handle) { var o = []; arr(d.trades).forEach(function (t) { if (t && t.handle === handle) o = arr(t.products); }); return rot(o, V); }
    var best = rot(arr(L.best), V), fresh = rot(arr(L.new), V), viewed = arr(L.viewed);
    var viewedMap = {}; readViewed().forEach(function (v) { viewedMap[v.h] = v.t; });
    var idxA = tradeBlock ? blocks.indexOf(tradeBlock) : (blocks.length ? V % blocks.length : 0);
    function nth(k) { return blocks.length ? blocks[((idxA + k) % blocks.length + blocks.length) % blocks.length] : null; }
    // A column needs at least two products. A try that fails gives its products back (they stay available to the next try).
    function attempt(fn) {
      var snap = {}, k;
      for (k in used) snap[k] = 1;
      var r = fn();
      if (!r) used = snap;
      return r;
    }
    function fit(it) { return it.length >= 4 ? it.slice(0, 4) : it.slice(0, 2); }
    function tradeCol(b, tag) {
      if (!b) return null;
      return attempt(function () {
        var it = items(tradeProducts(b.handle));
        return it.length >= 2 ? { title: b.short + ' Picks', tag: tag, kind: 'blue', items: fit(it), href: b.url, footer: 'Shop ' + b.short } : null;
      });
    }
    function anyTradeCol() {
      for (var i = 0; i < blocks.length; i++) { var c = tradeCol(blocks[(idxA + i) % blocks.length], 'BY TRADE'); if (c) return c; }
      return null;
    }
    function bestCol() {
      return attempt(function () {
        var it = items(best);
        return it.length >= 2 ? { title: 'Best Sellers', tag: 'TOP SELLERS', kind: 'dark', items: fit(it), href: '/collections/top-sellers', footer: 'Shop Best Sellers' } : null;
      });
    }
    function newCol() {
      return attempt(function () {
        var it = items(fresh, null, true);
        return it.length >= 2 ? { title: 'New This Month', tag: d.catalog && +d.catalog.new_30d > 0 ? num(+d.catalog.new_30d) + ' NEW' : 'NEW', kind: 'dark', items: fit(it), href: '/collections/all?sort_by=created-descending', footer: 'See Everything New' } : null;
      });
    }
    function keepCol() {
      return attempt(function () {
        var it = items(viewed);
        return it.length >= 2 ? { title: 'Keep Shopping For', tag: 'RECENT', kind: 'grey', items: fit(it), href: '', footer: 'Remembered on This Device' } : null;
      });
    }
    function againCol() {
      return attempt(function () {
        var it = items(arr(L.buy_again), function (p) { return 'Bought ' + (p.times || 1) + '\u00d7'; });
        return it.length >= 2 ? { title: 'Buy It Again', tag: 'FOR YOU', kind: 'blue', items: fit(it), href: '/apps/toolbox', footer: 'All Your Items in My Toolbox' } : null;
      });
    }
    var cols = [];
    if (linked) {
      var c1 = againCol() || bestCol();
      var c2 = newCol();
      var c3 = (tradeBlock && tradeCol(tradeBlock, 'YOUR TRADE')) || tradeCol(nth(0), 'BY TRADE') || anyTradeCol();
      var c4 = keepCol() || tradeCol(nth(1), 'BY TRADE') || anyTradeCol();
      cols = [c1, c2, c3, c4];
    } else {
      cols = [bestCol(), newCol(), tradeCol(nth(0), 'BY TRADE') || anyTradeCol(), keepCol() || tradeCol(nth(1), 'BY TRADE') || anyTradeCol()];
    }
    // any column that could not be built keeps its server-rendered version
    var slots = s.cols;
    cols.forEach(function (c, i) {
      if (c && slots[i]) slots[i].outerHTML = colHTML(c).replace('data-col', 'data-col data-slot="' + i + '"');
    });
    s.cols = Array.prototype.slice.call(s.root.querySelectorAll('[data-col]')).filter(function (el) { return !el.hasAttribute('data-guides'); });
  }

  /* =====================================================================
   * Wiring
   * ===================================================================== */
  var mosaics = [], shelves = [];
  function scan() {
    doc.querySelectorAll('[data-et-home="mosaic"]').forEach(function (root) {
      if (root.__ehm) return;
      var m = { root: root, data: readJSON(root), tiles: {}, forced: false, pinned: [], pinnedSlots: {} };
      root.querySelectorAll('[data-tile]').forEach(function (t) { m.tiles[t.getAttribute('data-tile')] = t; });
      m.cards = root.querySelector('[data-cards]');
      m.track = root.querySelector('[data-track]');
      if (m.track) Array.prototype.forEach.call(m.track.children, function (c, i) {
        if (c.hasAttribute('data-pinned')) { m.pinnedSlots[i] = true; m.pinned.push(c.getAttribute('data-handle')); }
      });
      var fm = root.getAttribute('data-money'); if (fm) moneyFmt = fm;
      if (m.tiles.toolbox && m.tiles.toolbox.getAttribute('data-state') === 'out') m.tbOrig = m.tiles.toolbox.innerHTML;
      // Debug switch: only on a theme that is not the published one.
      var role = root.getAttribute('data-theme-role');
      if (role && role !== 'main' && /[?&]et_home_as=customer(&|$)/.test(win.location.search)) {
        m.forced = true;
        var tpl = root.querySelector('template[data-signed-in]');
        if (tpl && m.tiles.toolbox) {
          var node = tpl.content.firstElementChild;
          if (node) { m.tiles.toolbox.replaceWith(node); m.tiles.toolbox = node; }
        }
      }
      root.__ehm = m;
      initCarousel(root);
      initCards(m);
      mosaics.push(m);
    });
    doc.querySelectorAll('[data-et-home="shelves"]').forEach(function (root) {
      if (root.__ehs) return;
      var s = { root: root, data: readJSON(root), head: root.querySelector('[data-sub-head]'), sub: root.querySelector('[data-sub-note]'), count: root.querySelector('[data-count]'), guides: root.querySelector('[data-guides-list]') };
      s.cols = Array.prototype.slice.call(root.querySelectorAll('[data-col]')).filter(function (el) { return !el.hasAttribute('data-guides'); });
      var fm = root.getAttribute('data-money'); if (fm) moneyFmt = fm;
      root.__ehs = s;
      shelves.push(s);
    });
    mosaics = mosaics.filter(function (m) { return doc.documentElement.contains(m.root); });
    shelves = shelves.filter(function (s) { return doc.documentElement.contains(s.root); });
  }

  function apply(json) {
    var d = json && typeof json === 'object' ? json : {};
    last = d;
    scan();
    mosaics.forEach(function (m) { try { renderMosaic(m, d); } catch (e) { win.console && console.warn('[et-home] mosaic', e); } });
    shelves.forEach(function (s) { try { renderShelves(s, d); } catch (e) { win.console && console.warn('[et-home] shelves', e); } });
  }

  function load() {
    if (!win.fetch) return;
    var h = readViewed().map(function (v) { return v.h; });
    var url = '/apps/toolbox/api/home' + (h.length ? '?viewed=' + encodeURIComponent(h.join(',')) : '');
    win.fetch(url, { credentials: 'same-origin', headers: { accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('home feed ' + r.status); return r.json(); })
      .then(function (j) { apply(j); })
      .catch(function (e) { if (win.console) console.warn('[et-home]', e && e.message ? e.message : e); });
  }

  win.etHome = { apply: apply, visit: function () { return V; } };

  function boot() {
    scan();
    apply(null);   // no feed yet: rotate the guide + trade tile only, leave everything else as rendered
    load();
    // theme editor: sections are re-rendered in place
    doc.addEventListener('shopify:section:load', function () { scan(); apply(last); });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
